<template>
  <div>
    <v-tabs
      fixed-tabs
      dark
      v-if="user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2' || user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'"
      height="35"
      dense
      v-model="selectedTab"
      class="fill-height promotion-tabs"
      background-color="#136DF5"
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#salespersons">Myyjät </v-tab>
      <!-- <v-tab href="#promotionPDFGeneratorOld">Nopea PDF tarjous</v-tab> -->
      <v-tab href="#office">Office</v-tab>
    </v-tabs>
    
    <v-container fluid style="height:100%" pa-0 ma-0 v-if="selectedTab === 'salespersons'">
      <v-toolbar class="avecor-table-toolbar" flat color="white">
        <v-toolbar-title>Viikkoraportti ({{selectedYear}})</v-toolbar-title>
        
        <v-spacer></v-spacer>
        
        
        <!--<v-btn @click.stop="importCompanies" color="#000000" dark class="add-button mb-2">Import</v-btn>-->
        <!--<input type="file" id="fileInput"></input>
        <button @click="importCompanies" id="submit_button">PARSE FILE</button>-->
        <v-autocomplete
          v-if="allAccess"
          style="max-width:200px;z-index:1000"
          label="Vuosi"
          v-model="selectedYear"
          :items="years"
          outlined
          dense
          persistent-hint
          class="avecor-select hide-field-details mr-5 mt-3"
        />
        <v-autocomplete
          v-if="allAccess"
          style="max-width:200px;z-index:1000"
          label="Valitse myyjä"
          :value="selectedSalesperson"
          @change="v => selectedSalesperson = v"
          :items="getSalespersons"
          outlined
          dense
          persistent-hint
          item-text="text"
          item-value="id"
          class="avecor-select hide-field-details mr-0 mt-3"
        />
        <!-- <v-btn v-if="device === 'desktop' && allAccess" @click.stop="setWeekReportsForSales()" color="#000000" dark class="avecor-button-global add-button mb-2 mr-5 mt-3" >Alusta</v-btn> -->
      </v-toolbar>
      <div v-if="getUser !== undefined && getUser.weekReports !== undefined" style="border-top:1px solid #ccc; position:absolute; top:70px; padding-bottom:150px; width:100%;">
        <v-row no-gutters v-for="i in 12" :key="'week-report-month-' + i" style="border:1px dotted #ccc" class="mt-5 mx-4" >
            <div class="px-2 pt-2" style="width:100%;"> {{months[i]}}</div>
            <v-col  v-for="j in avialableWeeksInMonth(selectedYear,i)" cols="2"  :key="'week-report-week-' + j.weekNo" class="px-2 py-2" >
              <div style="background:#eee;" class="px-2 py-2">
                <div style="font-size:12px;" class="ml-1">Viikko {{j.weekNo}}</div>
                <div class="mb-2 mt-2">
                  <v-text-field
                    :label="'Asiakaskäynnit'"
                    filled
                    placeholder=""
                    v-model="getUser.weekReports[selectedYear][i][j.weekNo].agreedVisits"
                    @blur="v => inlineSave({id:getUser.id,year:selectedYear,month:i,week:j.weekNo,field:'agreedVisits',value:v.target.value})"
                    hide-details
                    type="number"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    value=""/>
                </div>
                <div class="mb-2">
                  <v-textarea
                    label="Kommentit"
                    :auto-grow="true"
                    v-model="getUser.weekReports[selectedYear][i][j.weekNo].comments"
                    row-height="25"
                    @blur="v => inlineSave({id:getUser.id,year:selectedYear,month:i,week:j.weekNo,field:'comments',value:v.target.value})"
                    filled
                    hide-details
                    rows="3"/>
                </div>
              </div>
            </v-col>
        </v-row>
      </div>

      <!-- <div v-if="selectedSalesperson === 'no_selection'" style="border-top:1px solid #ccc; position:absolute; top:70px; padding-bottom:150px; width:100%;">
        <v-row v-for="i in 52" :key="'week-report-' + i" no-gutters >
            <div style="font-size:12px; width:100%" class="ml-1">Viikko {{i}}</div>
            <v-col cols="2" class="px-2 py-2" v-for="s in getSalespersonsAllFiltered" :key="s.id+'-week-report-'+i">
              
              <div style="background:#eee;" class="px-2 py-2" v-if="staff[s.id] !== undefined && staff[s.id].weekReports !== undefined">
                <div style="font-size:12px; width:100%" class="ml-1"> {{s.text}}</div>
                <div class="mb-2 mt-2">
                  <v-text-field
                    :label="'Asiakaskäynnit'"
                    filled
                    placeholder=""
                    v-model="staff[s.id].weekReports[selectedYear][i].agreedVisits"
                    @blur="inlineSave(staff[s.id])"
                    hide-details
                    type="number"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    value=""/>
                </div>
                <div class="mb-2">
                  <v-textarea
                      label="Kommentit"
                      :auto-grow="true"
                      v-model="staff[s.id].weekReports[selectedYear][i].comments"
                      row-height="25"
                      @blur="inlineSave(staff[s.id])"
                      filled
                      hide-details
                      rows="3"
                      />
                </div>
              </div>
            </v-col>
        </v-row>
      </div> -->



      <!-- <v-col cols="1" class="pa-2" v-for="index in 12" :key="item.id+'-sales-goal-'+index">
        <v-text-field
          v-model="item.goals[year][index]"
          @change="inlineSave(item)"
          class="avecor-select hide-field-details"
        ></v-text-field>
      </v-col> -->
      <!-- @blur="fieldUpdated('deliveryAddress')" -->
    </v-container>  
    <v-container fluid style="height:100%" pa-0 ma-0 v-if="selectedTab === 'office' && (user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2' || user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1')">
      <v-toolbar class="" flat dense style="border-top: 1px solid rgb(204, 204, 204); position: fixed; top: 84px; width: 100%; background: rgb(255, 255, 255) !important; z-index: 20;">
        <v-toolbar-title>Kirjautumiset</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-autocomplete
          v-if="allAccess"
          style="max-width:200px;z-index:1000"
          label="Vuosi"
          v-model="selectedYearForOffice"
          :items="yearsOffice"
          outlined
          dense
          persistent-hint
          class="avecor-select hide-field-details mr-5 mt-3"
        />
      </v-toolbar>
      <div style="margin-top:50px;border-top:1px solid #ccc;" v-if="getEntries && getEntries[0]">
        <v-row no-gutters style="font-size:11px;font-weight:600;" class="py-2">
          <v-col cols="1" style="" class="pl-3">
            Päivämäärä
          </v-col>
          <v-col cols="1" v-for="officeUser in getEntries[0].dayLogsArray" :key="officeUser.uid +'_logs_header'">
            <div>{{staff[officeUser.uid].firstName}}</div>
            <!-- <div v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'" style="font-size:7px;font-weight:400" >{{officeUser.uid}}</div> -->

          </v-col>
        </v-row>
        <v-row no-gutters v-for="(day,index) in getEntries" :key="day.ymd" style="border-top:1px solid #ccc;display:flex">
          <v-col cols="1" style="font-size:11px;" class="pl-3 pt-1">
            {{day.sort_label}}
          </v-col>
          <v-col cols="1" v-for="user in day.dayLogsArray" :key="day.ymd + user.uid">
            <div style="font-size:10px;">Sisään: <span style="font-size:12px;">{{user.firstLogin}}</span></div>
            <div style="font-size:10px;">Ulos: <span style="font-size:12px;">{{user.latestLogout}}</span></div>
          </v-col>
        </v-row>
        <!-- {{getEntries}} -->
      </div>

      <!-- <div v-if="selectedSalesperson === 'no_selection'" style="border-top:1px solid #ccc; position:absolute; top:70px; padding-bottom:150px; width:100%;">
        <v-row v-for="i in 52" :key="'week-report-' + i" no-gutters >
            <div style="font-size:12px; width:100%" class="ml-1">Viikko {{i}}</div>
            <v-col cols="2" class="px-2 py-2" v-for="s in getSalespersonsAllFiltered" :key="s.id+'-week-report-'+i">
              
              <div style="background:#eee;" class="px-2 py-2" v-if="staff[s.id] !== undefined && staff[s.id].weekReports !== undefined">
                <div style="font-size:12px; width:100%" class="ml-1"> {{s.text}}</div>
                <div class="mb-2 mt-2">
                  <v-text-field
                    :label="'Asiakaskäynnit'"
                    filled
                    placeholder=""
                    v-model="staff[s.id].weekReports[selectedYear][i].agreedVisits"
                    @blur="inlineSave(staff[s.id])"
                    hide-details
                    type="number"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    value=""/>
                </div>
                <div class="mb-2">
                  <v-textarea
                      label="Kommentit"
                      :auto-grow="true"
                      v-model="staff[s.id].weekReports[selectedYear][i].comments"
                      row-height="25"
                      @blur="inlineSave(staff[s.id])"
                      filled
                      hide-details
                      rows="3"
                      />
                </div>
              </div>
            </v-col>
        </v-row>
      </div> -->



      <!-- <v-col cols="1" class="pa-2" v-for="index in 12" :key="item.id+'-sales-goal-'+index">
        <v-text-field
          v-model="item.goals[year][index]"
          @change="inlineSave(item)"
          class="avecor-select hide-field-details"
        ></v-text-field>
      </v-col> -->
      <!-- @blur="fieldUpdated('deliveryAddress')" -->
    </v-container>  
  </div>

</template>


<script>
import { mapFields } from 'vuex-map-fields'
import firebase from 'firebase'
import dateFormat from 'dateformat'

var db = null


export default {
    components: {

    },
    data () {
      return {
        selectedTab:'salespersons',
        selectedSalesperson:'no_selection',
        selectedYear:2022,
        selectedYearForOffice:2025,
        yearsOffice:[2025,2026,2027,2028,2029,2030],
        years:[2022,2023,2024,2025],
        months:{
          1:"Tammikuu",
          2:"Helmikuu",
          3:"Maaliskuu",
          4:"Huhtikuu",
          5:"Toukokuu",
          6:"Kesäkuu",
          7:"Heinäkuu",
          8:"Elokuu",
          9:"Syyskuu",
          10:"Lokakuu",
          11:"Marraskuu",
          12:"Joulukuu"
        },
        configMap:{},
      }
    },
    mounted() {
      this.selectedYear = new Date().getFullYear()
      db = firebase.firestore();
      this.initiateConfig()
      /* var w15_2023 = this.getDataForWeek(1,2023)
      var w15_2024 = this.getDataForWeek(1,2024)
      var w15_2025 = this.getDataForWeek(1,2025)
      var w15_2026 = this.getDataForWeek(1,2026)
      var w15_2027 = this.getDataForWeek(1,2027)
      var w15_2028 = this.getDataForWeek(1,2028)
      var w15_2030 = this.getDataForWeek(1,2030)
      var w15_2032 = this.getDataForWeek(36,2032)
      console.log({w15_2023,w15_2024,w15_2025,w15_2026,w15_2027,w15_2028,w15_2030,w15_2032}) */
      //this.setWeekReportsForSales()
      //this.deleteOldWeekReports()
    },
    computed: {
      getEntries(){
        var officeUids = []
        Object.keys(this.staff).forEach(uid =>{
          if(this.staff[uid].role === 'office' && !this.staff[uid].isExit && uid !== 'shopify_kayttaja' && uid !== 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2') officeUids.push(uid)
        })
        var logs = this.configMap['logs']
        var entries = []
        var year = this.selectedYearForOffice

        if(!logs[year]) return entries
        var yearData = logs[year]
        console.log(logs)
        if(yearData){
          Object.keys(yearData).forEach(m => {
            Object.keys(yearData[m]).forEach(d => {
              var m_ = m.length == 1 ? '0'+m : m
              var d_ = d.length == 1 ? '0'+d : d
              var dayLogs = {}
              Object.keys(yearData[m][d]).forEach(uid => {
                console.log(uid)
                if(this.staff[uid]){
                  console.log("HERE")
                  var n = this.staff[uid].firstName
                  var firstLogin = ''
                  if(yearData[m][d][uid].login){
                    firstLogin = yearData[m][d][uid].login[0]
                    console.log(firstLogin)
                  }
                  var latestLogout = ''
                  if(yearData[m][d][uid].logout){
                    var l = yearData[m][d][uid].logout.length
                    latestLogout = yearData[m][d][uid].logout[length-1]
                  }
                  dayLogs[uid] = {
                    uid,
                    firstLogin:this.customFormatter(firstLogin),
                    latestLogout:latestLogout ? this.customFormatter(latestLogout) : ''
                  }
                }
              })
            
              var dayLogsArray = []

              officeUids.forEach(uid => {
                dayLogs[uid] ? dayLogsArray.push(dayLogs[uid]) : dayLogsArray.push({uid,firstLogin:'',latestLogout:''})
              })
              entries.push({
                sort_label:year+'-'+m_+'-'+d_,
                ymd:year+m_+d_,
                dayLogsArray
                
              })
            })
          })
        }
        entries = entries.sort((a,b)=>{
          var nameA=a.sort_label.toLowerCase().trim(), nameB=b.sort_label.toLowerCase().trim();
          if (nameA < nameB) {return 1;}
          if (nameB < nameA) {return -1;}
          return 0;
        })
        console.log(entries)
        return entries

      },

      getUser(){
        if (this.staff[this.user.uid] === undefined) return undefined
        if(this.allAccess && this.selectedSalesperson !== '') {
          return this.staff[this.selectedSalesperson]
        }
        else if(this.staff[this.user.uid].role === 'sales') return this.staff[this.user.uid]

        
        
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office')
      },
      getSalespersonsAllFiltered(){
        return this.getSalespersons.filter(s => {return s.id !== 'no_selection'})
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = [{text:'--Ei valintaa--', id:'no_selection'}]
        Object.keys(this.staff).forEach(key =>{
          var s = staff[key]
          //if(s.role === 'sales' && !s.isExit) salespersons.push({text:s.firstName, id:s.id})
          if(s.role === 'sales' && !s.isExit && s.weekReportingRequired) salespersons.push({text:s.firstName, id:s.id})
          // TOMI TESTING ONLY
          //else if(s.id === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1') salespersons.push({text:s.firstName, id:s.id})
        })
        salespersons = salespersons.sort((a,b)=>{
          var nameA=a.text.toLowerCase().trim(), nameB=b.text.toLowerCase().trim();
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })
        return salespersons
      },
      formTitle () {
      },
      ...mapFields([
        'settings',
        'user',
        'staff.staff',
        'device'
        
      ]),
    },
    created () {},
    methods: {
      initiateConfig(){
        var t= this
        db.collection("config")
        .onSnapshot(function(querySnapshot) {
            t.configMap = {}
            querySnapshot.forEach(function(doc) {
                t.configMap[doc.id] = {...doc.data(),id:doc.id}
            });
        })
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "HH:MM")
        }
        if (date._seconds) {
          var myDate = new Date(date._seconds*1000);
          return dateFormat(myDate, "HH:MM")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      avialableWeeksInMonth(year,month){
        var weeks = []
        Object.keys(this.getUser.weekReports[year][month]).forEach(weekNo => {
          weeks.push({weekNo,...this.getUser.weekReports[year][month][weekNo]})
        })
        weeks = weeks.sort((a,b)=>{
          var nameA=Number(a.weekNo), nameB=Number(b.weekNo);
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })
        //console.log(weeks)
        return weeks
      },
      /* getDataForWeek(weekNo,year){
        var d = new Date(year, 0, 1);
        var firstWeek = this.getFirstOfTheYearWeekNumber(year)
        if(firstWeek != 1){
          d = new Date(d.setDate(d.getDate() + 7))
        }
        
        var daysSinceMonday = d.getDay()-1
        //console.log(daysSinceMonday)
        if(daysSinceMonday < 0) daysSinceMonday = 6
        d.setDate(d.getDate() - daysSinceMonday);
        d.setDate(d.getDate() + ( 7 * (weekNo-1)));
        
        var startDay = d.getDate() 
        var startMonth = d.getMonth()+1
        var year = d.getFullYear()

        var wednesday = new Date(d.setDate(d.getDate() + 2))
        var thursday = new Date(d.setDate(d.getDate() + 1))
        var friday = new Date(d.setDate(d.getDate() + 1))
        var wednesdayMonth = wednesday.getMonth()+1
        var thursdayMonth = thursday.getMonth()+1
        var endDay = friday.getDate() 
        var endMonth = friday.getMonth()+1
        return {thursdayMonth,startDay,startMonth,endDay,endMonth,wednesdayMonth}
      }, */
      /* getFirstOfTheYearWeekNumber(year) {
        var date = new Date(year, 0, 1);
        //var date = new Date(this.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                              - 3 + (week1.getDay() + 6) % 7) / 7);
      }, */
      /* deleteOldWeekReports(){
        Object.keys(this.staff).forEach(s => {
          //console.log(s.id)
          this.$store.dispatch('staff/delete', `${s}.weekReports`)
        })
      }, */
      /* setWeekReportsForSales(){
        var data = null
        var weekReports = {}
        for (var i = 2022; i <= 2030; i++){
            weekReports[i] = {}
            for (var j = 1; j <= 53; j++){
              data = this.getDataForWeek(j,i)
              var period = data.startDay+'.'+data.startMonth+'-'+data.endDay+'.'+data.endMonth
              //console.log(data)
              //if(j== 53){console.log(data)}
              if(j == 53){
                if(data.thursdayMonth == 12){ 
                  weekReports[i][data.wednesdayMonth] === undefined ? weekReports[i][data.wednesdayMonth]={} : ''
                  weekReports[i][data.wednesdayMonth][j]={agreedVisits:0,comments:'',period,startDay:data.startDay,startMonth:data.startMonth,endDay:data.endDay,endMonth:data.endMonth}  
                  //console.log("year "+ i + ' 53 WEEKS');console.log(data); console.log(period)
                }
              }
              else {
                weekReports[i][data.wednesdayMonth] === undefined ? weekReports[i][data.wednesdayMonth]={} : ''
                weekReports[i][data.wednesdayMonth][j]={agreedVisits:0,comments:'',period,startDay:data.startDay,startMonth:data.startMonth,endDay:data.endDay,endMonth:data.endMonth}  
              }
            }
        }
        this.getSalespersonsAllFiltered.forEach(s => {
          this.$store.dispatch('staff/set', {
            id:s.id,
            weekReports
          })
        })
      }, */
      inlineSave(o) {
        console.log(o)
        var field ='weekReports.'+ o.year+'.'+o.month+'.'+o.week+'.'+o.field 


        this.$store.dispatch('staff/set', {
          id:o.id,
          [field]:o.value
        })
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      inlineSave2 (item) {
        let {id, ...y} = item;
        //console.log(id)
        //console.log(y)
        this.$store.dispatch('staff/set', {
          id,
          ...y
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/WeekReport.vue